export enum ColorsVariantEnum {
  ADDING = 'ADDING',
  DESCTRUCTIVE ='DESCTRUCTIVE',
  DEFAULT = 'DEFAULT'
}
